import React from "react";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

import TotalRecords from "../../../../components/core/total-records";
import NewDataTable from "../../../../components/new-core/data-table";
import { getStatusWithSuspendedCheck } from "../../../../utils/agent-helpers";
import { Dropdown } from "primereact/dropdown";
import { formatCurrencyValue, formatDate } from "../../../../utils/formatters";

const AgentTable = ({ data, headerClassName, selectable = true }) => {
  console.log({ data });
  const verificationStatusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value ?? null}
        options={[
          { value: "Unknown", label: "Unknown" },
          { value: "Blocked", label: "Blocked" },
          { value: "Suspended", label: "Suspended" },
          { value: "Active", label: "Active" },
        ]}
        onChange={(e) => {
          const value = e.target.value;
          options.filterCallback(value === "" || value === null ? null : value);
        }}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  return (
    <>
      {/* <TotalRecords type="Records" count={data?.length} /> */}
      <NewDataTable
        items={data}
        emptyMessage={`No agents found`}
        cellSelection={selectable}
        onCellClick={(e) => {
          const clickedField = e.field;

          console.log({ clickedField, DATA: e.rowData });

          switch (clickedField) {
            case "agentMobile":
              // pass partnerId + partnerAgentId
              window.open(
                `/operator/admin/agents/agentProfile/${e.rowData.partnerAgentId}`,
                "_blank",
              );
              break;

            case "agentName":
              // pass partnerId + partnerAgentId
              window.open(
                `/operator/admin/agents/agentProfile/${e.rowData.partnerAgentId}`,
                "_blank",
              );
              break;

            default:
              break;
          }
        }}
      >
        <Column
          header="Agent Name"
          headerClassName={headerClassName}
          alignHeader={"center"}
          field="agentName"
          className={`text-left p-4 font-bold  border border-gray-200 ${
            selectable ? `hover:text-blue-500 cursor-pointer` : "cursor"
          }`}
          body={(rowData) => {
            return (
              <div className="flex flex-col gap-0.5">
                <span>
                  {rowData.formattedAgentName !== " "
                    ? rowData.formattedAgentName
                    : "-"}{" "}
                </span>
                {rowData.hasIntegration && (
                  <span className="flex items-center gap-1 text-[11px] text-sky-600 font-medium">
                    <i
                      className="pi pi-verified text-sky-500"
                      style={{ fontSize: "0.75rem" }}
                    />
                    {rowData.partnerCompanyName ?? "Integrated Partner"}
                  </span>
                )}
              </div>
            );
          }}
        />
        <Column
          header="Agent Status"
          className="text-center border border-gray-200"
          headerClassName={headerClassName}
          // alignHeader={"center"}
          // sortable
          filter
          filterField="agentStatusLabel"
          showFilterMatchModes={false}
          showFilterMenuOptions={false}
          showAddButton={false}
          filterElement={verificationStatusFilterTemplate}
          filterMatchMode="equals"
          // sortable
          field="agentStatus"
          body={(rowData) => {
            return (
              <div className="flex justify-center">
                <Tag
                  value={getStatusWithSuspendedCheck(
                    rowData.agentStatus,
                    rowData.comments,
                  )}
                  className={`${
                    rowData.agentStatus === 1
                      ? "bg-green-400" // Active
                      : rowData.agentStatus === -1 &&
                          rowData.comments?.toLowerCase().includes("suspended")
                        ? "bg-orange-400" // Suspended
                        : rowData.agentStatus === -1
                          ? "bg-red-400" // Blocked
                          : "bg-gray-400" // Unknown (0 or any other value)
                  } text-secondary-purpleGray`}
                />
              </div>
            );
          }}
        />
        <Column
          header="Verified Status"
          sortable
          headerClassName={headerClassName}
          alignHeader={"center"}
          className="text-center border border-gray-200"
          field="verifiedStatus"
          body={(rowData) => {
            return (
              <div className="flex justify-center gap-2">
                <Tag
                  value={
                    rowData.verifiedStatus === 0
                      ? "Unverified"
                      : rowData.verifiedStatus === 1
                        ? "Verified"
                        : rowData.verifiedStatus === 2
                          ? "Pending Verification"
                          : rowData.verifiedStatus === 3
                            ? "Rejected"
                            : "Unknown"
                  }
                  className={`${
                    rowData.verifiedStatus === 0
                      ? "bg-gray-300/80"
                      : rowData.verifiedStatus === 1
                        ? "bg-green-400"
                        : rowData.verifiedStatus === 2
                          ? "bg-orange-400"
                          : rowData.verifiedStatus === 3
                            ? "bg-red-400"
                            : "bg-gray-500"
                  } text-secondary-purpleGray`}
                />
                {true &&
                  (rowData.verifiedStatus === 2 ||
                    rowData.verifiedStatus === 3) &&
                  rowData.rejectedIdPics?.length > 0 && (
                    <Tag
                      value="1 Step Away"
                      className="bg-primary-primaryYellowLight text-secondary-purpleGray"
                    />
                  )}
              </div>
            );
          }}
        />

        <Column
          header="Agent Mobile"
          headerClassName={headerClassName}
          alignHeader={"center"}
          className={`text-center border border-gray-200 ${
            selectable ? "cursor-pointer hover:text-blue-500" : ""
          }`}
          field="agentMobile"
        />
        <Column
          header="Partner Branch"
          headerClassName={headerClassName}
          alignHeader={"center"}
          field="partnerBranch"
          className="text-center border border-gray-200"
        />

        <Column
          header="Signup Date"
          headerClassName={headerClassName}
          alignHeader={"center"}
          field="signupDate"
          className="text-center border border-gray-200"
          sortable
          body={(rowData) => {
            return <div>{formatDate(rowData.signupDate)}</div>;
          }}
        />

        <Column
          field="createdAt"
          alignHeader={"center"}
          sortable
          header="Registration Date"
          headerClassName={headerClassName}
          className="text-center border border-gray-200"
          body={(rowData) => {
            return <div>{formatDate(rowData.createdAt)}</div>;
          }}
        />

        <Column
          header="MBOX Wallet Balance"
          headerClassName={headerClassName}
          alignHeader={"center"}
          sortable
          className="w-[150px] text-center border border-gray-200"
          field="walletBalance"
          body={(rowData) => {
            return <div>{formatCurrencyValue(rowData.walletBalance)}</div>;
          }}
        />
        <Column
          header="Last Dropoff"
          headerClassName={headerClassName}
          alignHeader={"center"}
          sortable
          className="w-[180px] text-center border border-gray-200"
          field="lastDropoffDate"
          body={(rowData) => {
            if (!rowData.lastDropoffDate && !rowData.lastDropoffLocker)
              return <div className="text-gray-400 text-center">—</div>;
            return (
              <div className="flex flex-col items-center gap-0.5 font-montserrat">
                <span className="text-sm font-semibold text-secondary-purpleGray leading-tight">
                  {rowData.lastDropoffLocker ?? "—"}
                </span>
                <span className="text-xs text-gray-400 leading-tight">
                  {rowData.lastDropoffDate
                    ? formatDate(rowData.lastDropoffDate)
                    : "—"}
                </span>
              </div>
            );
          }}
        />
      </NewDataTable>
    </>
  );
};

export default AgentTable;
